module.exports = __webpack_public_path__ + "media/images/success/appstore-5a9d5dc4ccf20ece0e7f05d4095f163f.png";